<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { RouterView, useRoute } from 'vue-router';

import AppShell from '@/components/AppShell.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import type { Notice } from '@/types/domain';

const notices = ref<Notice[]>([]);
const route = useRoute();

function receiveNotice(event: Event) {
  const notice = (event as CustomEvent<Notice>).detail;
  notices.value.push(notice);
  window.setTimeout(() => {
    notices.value = notices.value.filter((item) => item.id !== notice.id);
  }, 4200);
}

onMounted(() => window.addEventListener('eqs:notice', receiveNotice));
onBeforeUnmount(() => window.removeEventListener('eqs:notice', receiveNotice));
</script>

<template>
  <!-- public = 登录页；fullscreen = 大屏（需登录但不要壳） -->
  <RouterView v-if="route.meta.public || route.meta.fullscreen" />
  <AppShell v-else>
    <RouterView />
  </AppShell>
  <!-- 全局确认框：替代 window.confirm/prompt，挂在最外层，任何页面都能调用 -->
  <ConfirmDialog />
  <div class="notice-stack" aria-live="polite">
    <article v-for="notice in notices" :key="notice.id" class="notice" :class="`is-${notice.tone}`">
      <b>{{ notice.title }}</b>
      <span>{{ notice.message }}</span>
    </article>
  </div>
</template>
